module.exports = __webpack_public_path__ + "static/media/green-header.2eb6eb24.png";